<div *transloco="let t" class="flex flex-1 flex-col">
  <pxc-paywall-alert />

  <div *showIfStorageSpaceAvailable="null" class="flex flex-1 flex-col gap-6">
    <tui-stepper class="mb-2" [(activeItemIndex)]="pageStep">
      <button tuiStep type="button" [disabled]="isCreationOngoing()">{{ t('Informations') }}</button>
      <button
        tuiStep
        type="button"
        [disabled]="isSecondStepDisabled || isCreationOngoing()"
        [stepState]="!!patient ? 'pass' : 'normal'">
        {{ t('Patient') }}
      </button>
      <button tuiStep type="button" [disabled]="isSecondStepDisabled || isThirdStepDisabled || isCreationOngoing()">
        {{ t('Photos') }}
      </button>
    </tui-stepper>
    <section class="flex flex-1 flex-col" pxcSlidesScrollReset [tuiSlides]="slideDirection">
      @if (pageStep === SequenceCreateStep.INFORMATION) {
        <div class="flex flex-1 flex-col gap-6">
          <label tuiLabel>
            {{ t('Date et heure') }}
            <tui-textfield class="w-full">
              <input
                data-testid="input-date"
                name="sequenceDate"
                placeholder="{{ t('Entrez une date et une heure') }}"
                tuiInputDateTime
                [(ngModel)]="sequenceDataDate" />
              <tui-calendar *tuiDropdown />
            </tui-textfield>
          </label>
          <div class="flex flex-col gap-2">
            <h6 class="text-sm font-medium">{{ t('Groupes') }}</h6>
            @if (!telemonitoringId) {
              <pxc-department-picker
                data-testid="department-picker"
                [isClientChoiceDisabled]="true"
                [(clientCode)]="clientCode"
                [(departmentIds)]="departmentIds">
                @if (!telemonitoringId && departmentIds.length === 0 && clientCode !== commonClientCode) {
                  <tui-error
                    data-testid="no-department-selected-message"
                    [error]="t('Veuillez sélectionner au moins un groupe')" />
                }
              </pxc-department-picker>
            } @else {
              <div appearance="info" icon="@tui.info" size="m" tuiNotification>
                <div>
                  <p class="font-bold">{{ t('Vous créez une séquence rattachée à un télésuivi.') }}</p>
                  <p>{{ t('Elle sera partagée avec les mêmes groupes que son télésuivi.') }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (pageStep === SequenceCreateStep.PATIENT) {
        <section class="flex flex-1 flex-col">
          <pxc-patient-edit
            class="px-px"
            data-testid="input-patient"
            [clientCode]="clientCode"
            [displayActionButtons]="false"
            [patientEditionDisabled]="!!patient"
            [(patient)]="selectedPatient"
            (formValidityUpdate)="isPatientEditFormValid$.next($event)" />
        </section>
      }
      @if (pageStep === SequenceCreateStep.PICTURES) {
        <div class="flex flex-1 flex-col gap-6" data-testid="step-pictures">
          <section class="flex flex-col gap-2">
            <h6 class="text-sm font-medium">{{ t('Photos') }}</h6>
            <pxc-image-input
              data-testid="input-medias"
              ngDefaultControl
              [accept]="dropZoneAcceptValidator()"
              [isLongVideoEnabled]="isLongVideoEnabled()"
              [maxFileSize]="dropZoneMaxFileSize"
              [(ngModel)]="sequenceMedias" />
            @if (hasTooLargeImagePayload) {
              <tui-error
                data-testid="image-payload-too-large"
                [error]="t('La taille totale des photos ne peut pas dépasser 1 Go.')" />
            }
          </section>
          @if (hasPatient && (displayAnalysis$ | async)) {
            <section class="flex flex-col gap-2">
              <h6 class="text-sm font-medium">{{ t('Lésion') }}</h6>
              <pxc-sadm-analysis-input
                [clientCode]="clientCode"
                [formInputs]="formInputs"
                [patientId]="selectedPatient.id"
                [(analysisFormAnswer)]="createdAnalysisFormAnswer"
                [(protocolFormAnswer)]="createdProtocolFormAnswer"
                [(sadmEntityDraft)]="sadmEntityDraft"
                [(sadmEntityId)]="selectedSadmEntityId"
                (outputPictures)="onOutputPicturesChange($event)" />
            </section>
          }
          <section class="flex flex-col gap-2">
            <h6 class="text-sm font-medium">{{ t('Mots clés') }}</h6>
            <pxc-select-label
              data-testid="input-labels"
              [showFavoriteLabels]="true"
              [(selectedLabels)]="selectedLabels" />
          </section>
          <label tuiLabel>
            {{ t('Description') }}
            <tui-textfield tuiTextfieldSize="m">
              <textarea
                data-testid="input-description"
                maxlength="65535"
                name="sequenceDescription"
                placeholder="{{ t('Entrez une description (optionnel)') }}"
                tuiTextarea
                [min]="3"
                [(ngModel)]="description"></textarea>
            </tui-textfield>
          </label>
        </div>
      }
    </section>
    <footer class="mt-auto!" tuiFloatingContainer>
      @let footer = stepFooter;
      <div class="flex justify-between gap-2 max-md:flex-col-reverse">
        <button
          appearance="outline"
          tuiButton
          type="button"
          [disabled]="footer.previousButton.isDisabled"
          (click)="footer.previousButton.action()">
          {{ t(footer.previousButton.label) }}
        </button>
        <button
          tuiButton
          type="button"
          [attr.data-testid]="footer.nextButton.testId"
          [disabled]="footer.nextButton.isDisabled"
          [loading]="footer.nextButton.isLoading"
          (click)="footer.nextButton.action()">
          {{ t(footer.nextButton.label) }}
        </button>
      </div>
    </footer>
  </div>

  <ng-template [(tuiNotificationMiddle)]="isCreationOngoing">
    <tui-loader tuiAnimated />
    <div class="text-center" tuiAnimated>{{ t('Création en cours ...') }}</div>
  </ng-template>
</div>
